import * as PRIVILEGES from "../shared/constant/privileges.js";

const Home = {
  text: "Home",
  translate: "menu.dashboard",
  link: "/admin/home",
  icon: "far fa-chart-bar",
  privilegeName: PRIVILEGES.MENU_DASHBOARD,
};

const Settings = {
  text: "Settings",
  translate: "menu.settings",
  link: "/admin/settings/",
  icon: "fas fa-cog",
  privilegeName: PRIVILEGES.MENU_SETTINGS,
  submenu: [
    {
      text: "Company",
      translate: "menu.company",
      link: "/admin/settings/company",
      icon: "fas fa-user-tie",
      privilegeName: PRIVILEGES.MENU_COMPANY,
    },
    {
      text: "Sites",
      translate: "menu.sites",
      link: "/admin/settings/site",
      icon: "fas fa-building",
      privilegeName: PRIVILEGES.MENU_SITES,
    },
    {
      text: "Users",
      translate: "menu.users",
      link: "/admin/settings/users",
      icon: "fas fa-users",
      privilegeName: PRIVILEGES.MENU_USERS,
    },
    {
      text: "Workflow",
      translate: "menu.workflow",
      link: "/admin/settings/workflow",
      icon: "fas fa-code-branch",
      privilegeName: PRIVILEGES.MENU_WORKFLOW,
    },
    {
      text: "Deposits",
      translate: "menu.deposits",
      link: "/admin/settings/deposit",
      icon: "fas fa-warehouse",
      privilegeName: PRIVILEGES.MENU_DEPOSITS,
    },
    {
      text: "Payments",
      translate: "menu.payments",
      link: "/admin/settings/payment",
      icon: "fas fa-receipt",
      privilegeName: PRIVILEGES.MENU_PAYMENTS,
    },
    {
      text: "Discounts",
      translate: "menu.discounts",
      link: "/admin/settings/discount",
      icon: "fas fa-tags",
      privilegeName: PRIVILEGES.MENU_DISCOUNTS,
    },
    {
      text: "Rate",
      translate: "menu.rate",
      link: "/admin/settings/rate",
      icon: "fas fa-percent",
      privilegeName: PRIVILEGES.MENU_RATE,
    },
    {
      text: "Banks",
      translate: "menu.banks",
      link: "/admin/settings/bank",
      icon: "fas fa-university",
      privilegeName: PRIVILEGES.MENU_RATE, // TODO: sistemare privilegi MENU_BANKS
    }
  ],
};

const Anagraphics = {
  text: "Anagraphics",
  translate: "menu.anagraphics",
  link: "/admin/archives",
  icon: "fas fa-archive",
  privilegeName: PRIVILEGES.MENU_ARCHIVES,
  submenu: [
    // TODO: capire cosa fare con gli elementi di menu rimossi
    {
      text: "Nominative",
      translate: "menu.name_list",
      link: "/admin/archives/name-list",
      icon: "fas fa-smile",
      privilegeName: PRIVILEGES.MENU_ACCOUNTS,
    },
/*
    {
      text: "Customers",
      translate: "menu.customers",
      link: "/admin/archives/customer",
      icon: "fas fa-user",
      privilegeName: PRIVILEGES.MENU_CUSTOMERS,
    },
    {
      text: "Suppliers",
      translate: "menu.suppliers",
      link: "/admin/archives/supplier",
      icon: "fas fa-dolly",
      privilegeName: PRIVILEGES.MENU_SUPPLIERS,
    },
*/
    {
      text: "Subcontractor",
      translate: "menu.subcontractor",
      link: "/admin/archives/name-list/subcontractor",
      icon: "fas fa-user",
      privilegeName: PRIVILEGES.MENU_SUBCONTRACTOR,
    },
  ]
};

const Items = {
  text: "Archives",
  translate: "menu.items",
  icon: "fas fa-archive",
  privilegeName: PRIVILEGES.MENU_ITEMS,
  submenu: [
    {
      text: "Classifications",
      translate: "menu.item_classification",
      icon: "fas fa-angle-right",
      privilegeName: PRIVILEGES.MENU_ITEM_CATEGORIES,
      submenu: [
        {
          text: "Types",
          translate: "menu.item_type",
          link: "/admin/archives/items/classification/type",
          icon: "fas fa-angle-right",
          privilegeName: PRIVILEGES.MENU_ITEM_CATEGORIES,
        },
        {
          text: "Categories",
          translate: "menu.item_categories",
          link: "/admin/archives/items/classification/category",
          icon: "fas fa-angle-right",
          privilegeName: PRIVILEGES.MENU_ITEM_CATEGORIES,
        },
        {
          text: "Subcategories",
          translate: "menu.item_sub_categories",
          link: "/admin/archives/items/classification/sub_category",
          icon: "fas fa-angle-right",
          privilegeName: PRIVILEGES.MENU_ITEM_CATEGORIES,
        },
      ]
    },
    {
      text: "Items",
      translate: "menu.items",
      link: "/admin/archives/items",
      icon: "fas fa-boxes",
      privilegeName: PRIVILEGES.MENU_ITEMS,
    },
    {
      text: "Preconfigured items",
      translate: "menu.configuration_models",
      link: "/admin/archives/items/config-model",
      icon: "fas fa-boxes",
      privilegeName: PRIVILEGES.MENU_PRECONF_ITEMS,
    },
    {
      text: "Price lists",
      translate: "menu.price_lists",
      link: "/admin/archives/price-lists",
      icon: "fas fa-angle-right",
      privilegeName: PRIVILEGES.MENU_PRICE_LISTS,
      submenu: [
        {
          text: "Preconfigured customer lists",
          translate: "menu.preconfigured_customer_lists",
          link: "/admin/archives/price-lists/preconfigured-customer",
          icon: "fas fa-clipboard-list",
          privilegeName: PRIVILEGES.MENU_PRECONF_CUSTOMER_LIST,
        },
        {
          text: "Discount lists",
          translate: "menu.discount_lists",
          link: "/admin/archives/price-lists/discount",
          icon: "fas fa-clipboard-list",
          privilegeName: PRIVILEGES.MENU_PRECONF_CUSTOMER_LIST,
        },
      ]
    },
  ]
};

// TODO: sistemare privilegi
// ciclo attivo
const AccountsReceivable = {
  text: "Accounts payable",
  translate: "menu.accountsReceivable",
  icon: "fas fa-archive",
  privilegeName: PRIVILEGES.MENU_RECEIVABLES,
  submenu: [
    {
      text: "Preventivi",
      translate: "menu.quotes",
      link: "/admin/receivable/quote/all",
      icon: "fas fa-smile",
      privilegeName: PRIVILEGES.MENU_QUOTES,
    },
    {
      text: "Preventivi accettati",
      translate: "menu.quotes_accepted",
      link: "/admin/receivable/quote/accepted",
      fragment: "accepted",
      icon: "fas fa-smile",
      privilegeName: PRIVILEGES.MENU_QUOTES,
    },
    {
      text: "Customer orders",
      translate: "menu.customer_orders",
      link: "/admin/receivable/cust-order/all",
      icon: "fas fa-address-book",
      privilegeName: PRIVILEGES.MENU_CUSTOMER_ORDERS,
    },
    {
      text: "Advance payments",
      translate: "menu.advance_payments",
      link: "/admin/receivable/advance-payment/all",
      icon: "fas fa-address-book",
      privilegeName: PRIVILEGES.MENU_ADVANCE_PAYMENTS,
    },
    {
      text: "Distinte base",
      translate: "menu.boms",
      link: "/admin/receivable/bom/all",
      icon: "fas fa-address-book",
      privilegeName: PRIVILEGES.MENU_BOM,
    },
    {
      text: "SAL",
      translate: "menu.sal_project_summary",
      link: "/admin/receivable/sal/project",
      icon: "fas fa-address-book",
      privilegeName: PRIVILEGES.MENU_SAL,
    },
    {
      text: "SAL",
      translate: "menu.sal",
      link: "/admin/receivable/sal/all",
      icon: "fas fa-address-book",
      privilegeName: PRIVILEGES.MENU_SAL,
    },
    {
      text: "Invoices",
      translate: "menu.invoices",
      link: "/admin/receivable/invoice/all",
      icon: "fas fa-address-book",
      privilegeName: PRIVILEGES.MENU_CUSTOMER_INVOICE,
    },
    {
      text: "Credit notes",
      translate: "menu.creditNotes",
      link: "/admin/invoice/credit-note",
      icon: "fas fa-address-book",
      privilegeName: PRIVILEGES.MENU_CUSTOMER_ORDERS,
    },
  ]
};

// TODO: sistemare privilegi
// ciclo passivo
const AccountsPayable = {
  text: "Accounts receivable",
  translate: "menu.accountsPayable",
  icon: "fas fa-archive",
  privilegeName: PRIVILEGES.MENU_ARCHIVES,
  submenu: [
    {
      text: "Supplier orders",
      translate: "menu.supplier_orders",
      link: "/admin/orders/supplier",
      icon: "fas fa-address-book",
      privilegeName: PRIVILEGES.MENU_SUPPLIER_ORDERS,
    },
    {
      text: "DDT",
      translate: "menu.ddt",
      link: "/admin/orders/supplier",
      icon: "fas fa-address-book",
      privilegeName: PRIVILEGES.MENU_SUPPLIER_ORDERS,
    },
    {
      text: "Invoices",
      translate: "menu.invoices",
      link: "/admin/invoice/invoice",
      icon: "fas fa-address-book",
      privilegeName: PRIVILEGES.MENU_CUSTOMER_ORDERS,
    },
    {
      text: "Credit notes",
      translate: "menu.creditNotes",
      link: "/admin/invoice/credit-note",
      icon: "fas fa-address-book",
      privilegeName: PRIVILEGES.MENU_CUSTOMER_ORDERS,
    },
  ]
};

const Archives = {
  text: "Archives",
  translate: "menu.archives",
  link: "/admin/archives",
  icon: "fas fa-archive",
  privilegeName: PRIVILEGES.MENU_ARCHIVES,
  submenu: [
    // TODO: capire cosa fare con gli elementi di menu rimossi
    {
      text: "Customers",
      translate: "menu.customers",
      link: "/admin/archives/customer",
      icon: "fas fa-user",
      privilegeName: PRIVILEGES.MENU_CUSTOMERS,
    },
    {
      text: "Subcontractor",
      translate: "menu.subcontractor",
      link: "/admin/archives/subcontractor",
      icon: "fas fa-user",
      privilegeName: PRIVILEGES.MENU_SUBCONTRACTOR,
    },
    {
      text: "Suppliers",
      translate: "menu.suppliers",
      link: "/admin/archives/supplier",
      icon: "fas fa-dolly",
      privilegeName: PRIVILEGES.MENU_SUPPLIERS,
    },
    {
      text: "Nominative",
      translate: "menu.name_list",
      link: "/admin/archives/name-list",
      icon: "fas fa-smile",
      privilegeName: PRIVILEGES.MENU_ITEMS, // TODO: sistemare privilegi MENU_NAME_LIST
    },
    {
      text: "Items",
      translate: "menu.items",
      icon: "fas fa-boxes",
      privilegeName: PRIVILEGES.MENU_ITEMS,
      submenu: [
        {
          text: "Classifications",
          translate: "menu.item_classification",
          icon: "fas fa-angle-right",
          privilegeName: PRIVILEGES.MENU_ITEM_PURPOSES,
          submenu: [
            {
              text: "Types",
              translate: "menu.item_type",
              link: "/admin/archives/items/classification/type",
              icon: "fas fa-angle-right",
              privilegeName: PRIVILEGES.MENU_ITEMS,
            },
            {
              text: "Categories",
              translate: "menu.item_categories",
              link: "/admin/archives/items/classification/category",
              icon: "fas fa-angle-right",
              privilegeName: PRIVILEGES.MENU_ITEMS,
            },
            {
              text: "Subcategories",
              translate: "menu.item_sub_categories",
              link: "/admin/archives/items/classification/sub_category",
              icon: "fas fa-angle-right",
              privilegeName: PRIVILEGES.MENU_ITEMS,
            },
          ]
        },
        {
          text: "Items",
          translate: "menu.items",
          link: "/admin/archives/items",
          icon: "fas fa-boxes",
          privilegeName: PRIVILEGES.MENU_ITEMS,
        },
        {
          text: "Preconfigured items",
          translate: "menu.configuration_models",
          link: "/admin/archives/items/config-model",
          icon: "fas fa-angle-right",
          privilegeName: PRIVILEGES.MENU_PRECONF_ITEMS,
        },
      ]
    },
    {
      text: "Price lists",
      translate: "menu.price_lists",
      link: "/admin/archives/price-lists",
      icon: "fas fa-clipboard-list",
      privilegeName: PRIVILEGES.MENU_PRICE_LISTS,
      submenu: [
        {
          text: "Preconfigured customer lists",
          translate: "menu.preconfigured_customer_lists",
          link: "/admin/archives/price-lists/preconfigured-customer",
          icon: "fas fa-angle-right",
          privilegeName: PRIVILEGES.MENU_PRECONF_CUSTOMER_LIST,
        },
        {
          text: "Discount lists",
          translate: "menu.discount_lists",
          link: "/admin/archives/price-lists/discount",
          icon: "fas fa-angle-right",
          privilegeName: PRIVILEGES.MENU_PRECONF_CUSTOMER_LIST,
        },
      ]
    },
  ]
};

const Project = {
  text: "Project",
  translate: "menu.project",
  icon: "fas fa-project-diagram",
  privilegeName: PRIVILEGES.MENU_PROJECT,
  submenu: [
    {
      text: "Category",
      translate: "menu.category",
      link: "/admin/project/project-sections/category",
      icon: "fas fa-cubes",
      privilegeName: PRIVILEGES.MENU_PROJECT_CATEGORY,
    },
    // {
    //   text: "Typology",
    //   translate: "menu.typology",
    //   link: "/admin/project/project-sections/typology",
    //   icon: "fas fa-cubes",
    //   privilegeName: PRIVILEGES.MENU_PROJECT_TYPE,
    // },
    {
      text: "Project",
      translate: "menu.project",
      link: "/admin/project/list",
      icon: "fas fa-project-diagram",
      privilegeName: PRIVILEGES.MENU_PROJECT,
    }
  ]
};

const Orders = {
  text: "Orders",
  translate: "menu.orders",
  link: "/admin/orders",
  icon: "fas fa-clipboard-check",
  privilegeName: PRIVILEGES.MENU_ORDERS,
  submenu: [
    // {
    //   text: "Order types",
    //   translate: "menu.order_types",
    //   link: "/admin/orders/type",
    //   icon: "fas fa-list-ul",
    //   privilegeName: PRIVILEGES.MENU_ORDER_TYPES,
    // },
    // {
    //   text: "Numbering orders",
    //   translate: "menu.numbering_orders",
    //   link: "/admin/orders/numbering",
    //   icon: "fas fa-list-ol",
    //   privilegeName: PRIVILEGES.MENU_NUMBERING_ORDERS,
    // },
  ]
};

const Warehouse = {
  text: "Warehouse",
  translate: "menu.warehouse",
  link: "/admin/warehouse",
  icon: "fas fa-warehouse",
  privilegeName: PRIVILEGES.MENU_WAREHOUSE,
  submenu: [
    {
      text: "Inventory movements",
      translate: "menu.inventory_movements",
      link: "/admin/warehouse/movements",
      icon: "fas fa-exchange-alt",
      privilegeName: PRIVILEGES.MENU_INVENTORY_MOVEMENT,
    },
  ]
};

export let MENU = [
  Home,
  Settings,
  Anagraphics,
  Items,
  AccountsReceivable,
  AccountsPayable,
  Project
];
